import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '@mos-front-components/public/es/components/PguFormGrid/PguFormGrid.pcss';

import Modal from '@mos-cat/modal';
import TextArea from '@mos-cat/text-area';
import MaskedField from '@mos-cat/masked-field';
import TextField from '@mos-cat/text-field';

import Button from '../../components/Button/Button';
import Content from '../../components/Content/Content';

import {
  unsetNotCorrectExam,
  changeNotCorrectExamForm,
  submitNotCorrectExamForm
} from '../../store/notCorrectExam/actions';
import { saveDraft } from '../../store/draft/actions';
import {
  notCorrectExamStructuredSelector,
  notCorrectExamStructuredSelectorDefaultProp,
  notCorrectExamStructuredSelectorPropTypes
} from './notCorrectExamStructuredSelector';

import './NotCorrectExam.pcss';

import { phoneMaskOptions } from '../../helpers/maskOptions';
import { EMOJI_REGEXP } from '../../constants/regexp';

class NotCorrectExam extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleBlur = (field, value) => {
    const valid = true;
    const blur = true;
    const message = null;
    this.props.changeNotCorrectExamForm({
      field,
      value,
      valid,
      message,
      blur
    });
    this.props.saveDraft();
  };

  handleClose() {
    if (!this.props.loading) {
      this.props.unsetNotCorrectExam();
    }
    this.props.saveDraft();
  }

  handleChange(field, baseValue, isText) {
    const valid = true;
    const message = null;
    const value = isText ? baseValue.replace(EMOJI_REGEXP, '') : baseValue;
    this.props.changeNotCorrectExamForm({
      field,
      value,
      valid,
      message
    });
  }

  render() {
    const { loading, visibleForm, form } = this.props;

    return (
      <React.Fragment>
        <Modal
          visible={visibleForm}
          className="NotCorrectExamModal"
          onCancel={this.handleClose}
        >
          <h3 className="Modal__title">
            Несоответствие бланков ответов/аудиозаписей устных ответов вашей
            работе
          </h3>
          <Content>
            <Content.Text style={{ color: '#0C1014' }}>
              Вы не подтвердили соответствие бланков ответов/аудиозаписей устных
              ответов вашей экзаменационной работе. Подача апелляции невозможна.
              Информация о несоответствии бланков ответов/аудиозаписей устных
              ответов будет направлена в Региональный центр обработки информации
              города Москвы (РЦОИ).
            </Content.Text>
            <Content.Text style={{ color: '#0C1014', marginBottom: 16 }}>
              Внесите комментарий с описанием несоответствия бланков
              ответов/аудиозаписей устных ответов экзаменационной работы. К
              примеру, «Не хватает одного дополнительного бланка ответов №2».
            </Content.Text>
            <Content.Text style={{ color: '#0C1014', marginBottom: 16 }}>
              Обратите внимание! Одновременная подача заявления о несоответствии
              бланков ответов/аудиозаписей устных ответов и заявления на
              рассмотрение апелляции о несогласии с выставленными баллами
              невозможна.
            </Content.Text>
            <div className="PguFormGrid__row" style={{ marginBottom: 24 }}>
              <div className="PguFormGrid_col">
                <TextArea
                  name="NotCorrectExamText"
                  rows={2}
                  label="Комментарий"
                  className="PguFormGrid__field"
                  value={form.comment.value}
                  error={form.comment.message}
                  maxLength={1000}
                  onChange={event =>
                    this.handleChange(
                      'comment',
                      event.currentTarget.value,
                      true
                    )
                  }
                  onBlur={() => this.handleBlur('comment', form.comment.value)}
                />
              </div>
            </div>
            <Content.Text style={{ marginBottom: 16, color: '#0C1014' }}>
              Укажите актуальные контактные данные для информирования по итогам
              проверки
            </Content.Text>
            <div className="PguFormGrid__row" style={{ marginBottom: 32 }}>
              <div className="PguFormGrid_col">
                <MaskedField
                  label="Контактный телефон"
                  maskOptions={phoneMaskOptions}
                  className="PguFormGrid__field"
                  value={form.phone.value}
                  error={form.phone.message}
                  onChange={ev =>
                    this.handleChange('phone', ev.currentTarget.value)
                  }
                  onBlur={() => this.handleBlur('phone', form.phone.value)}
                />
              </div>
              <div className="PguFormGrid_col">
                <TextField
                  label="Адрес электронной почты"
                  className="PguFormGrid__field"
                  value={form.email.value}
                  error={form.email.message}
                  maxLength={100}
                  onChange={ev =>
                    this.handleChange('email', ev.currentTarget.value, true)
                  }
                  onBlur={() => this.handleBlur('email', form.email.value)}
                />
              </div>
            </div>
            <Content.Text
              style={{
                fontStyle: 'italic',
                color: '#6A6E72'
              }}
            >
              <p x-ms-format-detection="none">
                По всем дополнительным вопросам вы можете обратиться в
                региональный центр обработки информации города Москвы по
                телефону{' '}
                <a
                  className="Link"
                  rel="noopener noreferrer"
                  href="tel:+74996539450"
                >
                  +7 499 653-94-50
                </a>
              </p>
            </Content.Text>
            <Content.Button style={{ marginBottom: 0 }}>
              <Button
                className="NotCorrectExam__button NotCorrectExam__button_submit"
                primary
                disabled={!form.valid}
                progress={loading || undefined}
                onClick={() => this.props.submitNotCorrectExamForm()}
              >
                Отправить
              </Button>
              <Button
                className="NotCorrectExam__button NotCorrectExam__button_cancel"
                onClick={this.handleClose}
                disabled={loading}
                type="link"
              >
                Отменить
              </Button>
            </Content.Button>
          </Content>
        </Modal>
      </React.Fragment>
    );
  }
}

NotCorrectExam.propTypes = {
  ...notCorrectExamStructuredSelectorPropTypes,
  unsetNotCorrectExam: PropTypes.func.isRequired,
  changeNotCorrectExamForm: PropTypes.func.isRequired,
  submitNotCorrectExamForm: PropTypes.func.isRequired
};

NotCorrectExam.defaultProps = notCorrectExamStructuredSelectorDefaultProp;

export default connect(notCorrectExamStructuredSelector, dispatch =>
  bindActionCreators(
    {
      unsetNotCorrectExam,
      changeNotCorrectExamForm,
      submitNotCorrectExamForm,
      saveDraft
    },
    dispatch
  )
)(NotCorrectExam);
